import styled from "styled-components";

export const Link = styled.a`
  cursor: pointer;
`;
